import useDSApplicationMode from '../../hooks/useDSApplicationMode'
import { useExperienceNavControlsRolloutEnabled } from './useExperienceNavControlsRollout'

export const KIOSK_NAV_VARIANTS = {
  HIDDEN: 'hidden',
  LEGACY_STATION_MENU: 'legacy-station-menu',
  SHARED_CONTROLS: 'shared-controls',
}

export default function useKioskNavigationPolicy({ hideKioskHeader = false } = {}) {
  const appMode = useDSApplicationMode()
  const rolloutEnabled = useExperienceNavControlsRolloutEnabled()
  const isStation = appMode === 'STATION'

  let kioskNavVariant = KIOSK_NAV_VARIANTS.HIDDEN
  if (isStation && !hideKioskHeader) {
    if (rolloutEnabled) {
      kioskNavVariant = KIOSK_NAV_VARIANTS.SHARED_CONTROLS
    } else {
      kioskNavVariant = KIOSK_NAV_VARIANTS.LEGACY_STATION_MENU
    }
  }

  const showLeaveKioskAction = kioskNavVariant === KIOSK_NAV_VARIANTS.SHARED_CONTROLS

  return {
    kioskNavVariant,
    showLeaveKioskAction,
    sharedNavOwnsIdleTimer: showLeaveKioskAction,
  }
}
